// LoadingSpinner.js
import React from "react";
import { RotatingLines } from "react-loader-spinner";
import PropTypes from "prop-types";

const LoadingSpinner = ({
  text,
  height,
  width,
  strokeWidth,
  animationDuration,
}) => {
  return (
    <div className="loading-wrap">
      <div>
        <h2 className="loading-text">{text || "Loading..."}</h2>
        <RotatingLines
          visible={true}
          height={height || "96"}
          width={width || "96"}
          strokeWidth={strokeWidth || "5"}
          animationDuration={animationDuration || "0.75"}
          ariaLabel="rotating-lines-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    </div>
  );
};

LoadingSpinner.propTypes = {
  text: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  strokeWidth: PropTypes.string,
  animationDuration: PropTypes.string,
};

export default LoadingSpinner;
